import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Components
import Loader from "./Loader";
import Navbar from "./Navbar";
import Footer from "./Footer";

// Home Page (contains all sections)
import Apexoindustrial from "./apexo/Home/Apexoindustrial";

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);

  }, []);

  if (loading) {
    return <Loader />;
  }

  return (

    <div className="app-wrapper">

      {/* Navbar */}
      <Navbar />

      {/* Main Content */}

      <main className="main-content">

        <Routes>

          <Route
            path="/"
            element={<Apexoindustrial />}
          />

        </Routes>

      </main>

      {/* Footer */}

      <Footer />

    </div>

  );

}

export default App;